"use client";
import { useEffect } from "react";
import AppDialog from "../AppDialog";
import "./style.css";

interface IAppModalProps {
  children: React.ReactNode;
  header: string;
  subtitle?: string;
  open: any;
  onHide: () => void;
  className?: string;
  closable?: boolean;
  draggable?: boolean;
  headerBtn?: React.ReactNode;
  closeOnEscape?: boolean;
  closeOnOverlayClick?: boolean;
}

const AppModal = ({
  children,
  header,
  headerBtn,
  subtitle,
  open,
  onHide,
  className,
  closable = true,
  draggable,
  closeOnEscape = true,
  closeOnOverlayClick = true,
}: IAppModalProps) => {
  useEffect(() => {
    // Melhor gerenciamento de scroll quando há múltiplos overlays (sidebar + modal)
    if (open) {
      const currentOverflow = document.body.style.overflow;
      if (currentOverflow !== "hidden") {
        document.body.style.overflow = "hidden";
      }
    }

    return () => {
      if (!open) {
        // Só restaura o overflow se não há outros modais/overlays ativos
        const activeDialogs = document.querySelectorAll(
          ".dialog-overlay, .app-sidebar-overlay",
        );
        if (activeDialogs.length === 0) {
          document.body.style.overflow = "";
        }
      }
    };
  }, [open]);

  const newHeader = () => {
    return (
      <div className="app-modal-header">
        <h4>{header}</h4>
        {subtitle && <h5 className="app-modal-subtitle">{subtitle}</h5>}
        {headerBtn && <div className="app-modal-header-btn">{headerBtn}</div>}
      </div>
    );
  };

  return (
    <AppDialog
      maskClassName={`custom_dialog_master p-4`}
      header={newHeader()}
      visible={open}
      onHide={onHide}
      className={`custom_dialog_master app-modal-content ${className || ""}`}
      closable={closable}
      draggable={draggable}
      closeOnEscape={closeOnEscape}
      closeOnOverlayClick={closeOnOverlayClick}
    >
      {children}
    </AppDialog>
  );
};

export default AppModal;
